// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"ef5577abf9d011fa2b2b","535":"4bdcebcacca8a7b59ada","553":"1fef529ec98ffcb284c9","896":"1c809d8801e2334d4a0a","912":"e58cd4f26904f4613f67"}[chunkId] + ".chunk.js";
};